module.exports = __webpack_public_path__ + "img/94038.73d7501c.svg";